import type { ThemeTokens } from '../api/shopPresets';
import { applyThemeTokens } from './applyTheme';

const KEY = 'shopTheme';

export function readCachedTheme(): ThemeTokens | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as ThemeTokens) : null;
  } catch {
    return null;
  }
}

export function writeCachedTheme(tokens: ThemeTokens | null): void {
  try {
    if (tokens) localStorage.setItem(KEY, JSON.stringify(tokens));
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode / quota — ignore */
  }
}

/**
 * Synchronously apply the last-known theme before React renders. localStorage is
 * per-origin, so each shop is naturally isolated. First-ever visit has no cache
 * (brief default-theme paint); repeat visits never flash.
 */
export function applyCachedThemeOnBoot(): void {
  const cached = readCachedTheme();
  if (cached) applyThemeTokens(cached);
}
